import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "../../../components/UI Component/Modal/commonModals.css";
import Reschedule from "../../../assets/image-removebg-preview.png";
import Loader from "../../UI Component/Loader/Loader";
import "./style/shareModal.css"
import { propTypes } from "react-bootstrap/esm/Image";

const CancelAppointmentModal = ({
    show,
    handleClose,
    cancelAppointInstantData,
    fees
    }) => {
        const [loading, setloading] = useState(false);


    return (
        <>
        {loading ? <Loader /> : null}
            {show?<Modal show={show} onHide={handleClose} backdrop="static" centered>
                <Modal.Body>
                    <div className="d-flex align-items-center justify-content-end w-100 px-4 pt-2">
                        {/* <div onClick={handleClose} className="cursor-pointer">
                            Close X
                        </div> */}
                    </div>
                    <div className="d-flex align-items-center justify-content-center flex-column p-4">
                        <div className="swal-icon swal-icon--info">
                            {/* <img src={Reschedule} /> */}
                        </div>
                        <div className="reschedule-title">Confirm Cancellation</div>
                        <div className="reschedule-text px-3 my-3" style={{ maxWidth: "505px"}}>
                            On cancellation, user would be refunded Rs.{''}{fees}, Do you really want to cancel an appointment?
                        </div>

                        <div style={{width: "100%", textAlign: "right"}}>
                            <button className="btn primary-cta-button mt-3 p-3"  onClick={cancelAppointInstantData}>
                                OK
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>:null}
        </>
    );
};

export default CancelAppointmentModal;